module.exports = __webpack_public_path__ + "static/img/图层37.0b950ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层37.png
// module id = Qw82
// module chunks = 0